import { render } from "./Preferencias.vue?vue&type=template&id=c56dcc4a"
import script from "./Preferencias.vue?vue&type=script&lang=js"
export * from "./Preferencias.vue?vue&type=script&lang=js"
script.render = render

export default script